import { render, staticRenderFns } from "./faq-panel.vue?vue&type=template&id=77c7ee2f"
import script from "./faq-panel.vue?vue&type=script&lang=js"
export * from "./faq-panel.vue?vue&type=script&lang=js"
import style0 from "./faq-panel.vue?vue&type=style&index=0&id=77c7ee2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports